<div
  class="u-height-100"
  [ngStyle]="{ 'min-width': '70px' }"
  fxLayout="row"
  fxLayoutAlign="start center"
>
  <div
    *ngIf="primaryIcon"
    fxLayout="row"
    fxLayoutAlign="end center"
    class="u-paddingRight-16"
  >
    <i class="material-icons md-18">
      {{ primaryIcon }}
    </i>
  </div>
  <div fxLayout="row" fxLayoutAlign="start end">
    <b i18n="@@settingsView.title">{text, select, other {{{ text }}}}</b>
  </div>
  <div
    *ngIf="secondaryIcon"
    fxLayout="row"
    fxLayoutAlign="end end"
    class="u-paddingLeft-8"
  >
    <i class="material-icons md-18">
      {{ secondaryIcon }}
    </i>
  </div>
</div>
